import React from "react";
import "./ViewCertificateCorporateAccountPage.scss";
import ViewCertificateCorporateAccount from "../../features/ViewCertificateCorporateAccount/ViewCertificateCorporateAccount";

const ViewCertificateCorporateAccountPage = () => {
    return (
        <div>
            <ViewCertificateCorporateAccount />
        </div>
    );
};

export default ViewCertificateCorporateAccountPage;